







































import { Component, Vue, Watch } from "vue-property-decorator";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";
import EntityModal from "@/layouts/DashboardLayoutComponents/EntityModal.vue";

import userModel from "@/models/user.model";
import unitManagerModel from "@/models/unitManager.model";
import unitModel from "@/models/unit.model";

@Component({
	name: "unitManagers",
	components: {
		PaginatedSearch,
		CreationCard,
		FormField,
		EntityModal
	},
})
export default class AdminUnitManagers extends Vue {
	id: any = "";
	userId: any = "";

	unitManagerModel: any;
	unitManagerCreationFields = [
		{ key: "name", class: "md-size-50" },
		{ key: "cnpj", class: "md-size-25" },
		{ key: "address.phone", class: "md-size-25" },
		{ key: "address.postalCode", class: "md-size-20" },
		{ key: "address.street", class: "md-size-30" },
		{ key: "address.number", class: "md-size-20" },
		{ key: "address.complement", class: "md-size-30" },
		{ key: "address.state", class: "md-size-20" },
		{ key: "address.city", class: "md-size-30" },
		{ key: "address.district", class: "md-size-30" },
	];
	unitManagerModalFields = [
		{ icon: "edit", name: "Dados", fields: [
			{ key: "name", class: "md-size-50" },
			{ key: "cnpj", class: "md-size-25" },
			{ key: "address.phone", class: "md-size-25" },
			{ key: "address.postalCode", class: "md-size-20" },
			{ key: "address.street", class: "md-size-40" },
			{ key: "address.number", class: "md-size-20" },
			{ key: "address.complement", class: "md-size-20" },
			{ key: "address.state", class: "md-size-20" },
			{ key: "address.city", class: "md-size-30" },
			{ key: "address.district", class: "md-size-25" },
		]},
		{ icon: "store", name: "Unidades administradas", slot: "units-tab" },
		{ icon: "delete", name: "Excluir", fields: [
			{ key: "name", class: "md-size-50", props: { disabled: true } },
			{ key: "deletionReason", class: "md-size-50" },
		]},
	];

	units: any[] = [];

	userModel: any;
	userCreationFields = [
		{ key: "name", class: "md-size-100" },
		{ key: "email", class: "md-size-50" },
		{ key: "password", class: "md-size-50" },
		{ key: "userUnitManager", class: "md-size-50", props: { manyToOneModel: unitManagerModel } },
	];

	userModalFields = [
		{ icon: "edit", name: "Dados", fields: this.userCreationFields },
		{ icon: "delete", name: "Excluir", fields: [
			{ key: "name", class: "md-size-50", props: { disabled: true } },
			{ key: "deletionReason", class: "md-size-50" },
		]},
	];

	constructor() {
		super();
		this.unitManagerModel = unitManagerModel;
		this.userModel = userModel;
	}

	async mounted() {
		this.updateRoute(this.$route);
	}

	async loadUnits(unitManagerId: any) {
		this.units = [];
		const unitManagers = await unitManagerModel.search({ search: { id: unitManagerId } }, false, "units");
		if (unitManagers?.length && unitManagers[0].units) {
			const { units } = unitManagers[0];
			this.units = units.sort((a: any, b: any) => a.name.localeCompare(b.name));
		}
	}

	@Watch("$route")
	updateRoute(route: any) {
		if (route.params.id?.indexOf("u") === 0) {
			this.userId = route.params.id.replace("u", "");
		} else if (route.params.id) {
			this.id = route.params.id;
			this.loadUnits(this.id).catch((error: any) => console.error(error));
		} else {
			this.id = "";
			this.userId = "";
		}
	}

	openUnitManager(unitManager: any) {
		this.$router.push(`/administrativo/administradora/${unitManager.id}`);
	}

	closeUnitManager() {
		this.$router.push('.');
		(this.$refs.unitManagerSearch as any).refresh();
	}

	openUser(user: any) {
		this.$router.push(`/administrativo/administradora/u${user.id}`);
	}

	closeUser(user: any) {
		this.$router.push('.');
		(this.$refs.userSearch as any).refresh();
	}
}
